/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Profile_Name_PlaceholderInputs */

const en_company_profile_name_placeholder = /** @type {(inputs: Company_Profile_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Official Company Name`)
};

const de_company_profile_name_placeholder = /** @type {(inputs: Company_Profile_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offizieller Name der Firma`)
};

/**
* | output |
* | --- |
* | "Official Company Name" |
*
* @param {Company_Profile_Name_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_profile_name_placeholder = /** @type {((inputs?: Company_Profile_Name_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Profile_Name_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_profile_name_placeholder(inputs)
	return en_company_profile_name_placeholder(inputs)
});